export interface MarketplaceOffer {
  id: number;
  name: string;
  advertiser: string;
  radioName: string;
  format: 'banner' | 'audio' | 'video' | 'patrocinio' | 'mencion';
  duration: string;
  price: number;
  availability: string;
  startDate: string;
  endDate: string;
  description: string;
  status: 'activo' | 'pausado' | 'archivado';
  impressions: number;
  clicks: number;
  ctr: number;
}

export const marketplaceOffers: MarketplaceOffer[] = [
  {
    id: 1, name: 'Banner Premium Home', advertiser: 'Banco Santander', radioName: 'Radio Éxito FM',
    format: 'banner', duration: '3 meses', price: 45000, availability: 'Alta',
    startDate: '2026-06-01', endDate: '2026-09-01',
    description: 'Banner principal en la home de la radio. Máxima visibilidad. Rotación diaria en franja prime time.',
    status: 'activo', impressions: 245000, clicks: 18200, ctr: 7.4,
  },
  {
    id: 2, name: 'Cuña Radio Matinal', advertiser: 'AutoLux Premium', radioName: 'Radio Industria',
    format: 'audio', duration: '6 meses', price: 38000, availability: 'Media',
    startDate: '2026-05-15', endDate: '2026-11-15',
    description: 'Cuña de 30 segundos en el programa matutino. 3 repeticiones por hora.',
    status: 'activo', impressions: 178000, clicks: 12300, ctr: 6.9,
  },
  {
    id: 3, name: 'Video Pre-roll Streaming', advertiser: 'TechNova Solutions', radioName: 'Radio Élite Digital',
    format: 'video', duration: '4 meses', price: 62000, availability: 'Baja',
    startDate: '2026-07-01', endDate: '2026-11-01',
    description: 'Video pre-roll de 15 segundos antes del streaming en vivo. No skippable.',
    status: 'activo', impressions: 132000, clicks: 8900, ctr: 6.7,
  },
  {
    id: 4, name: 'Patrocinio Evento Deportivo', advertiser: 'Gimnasio PowerFit', radioName: 'Radio Deportiva Total',
    format: 'patrocinio', duration: '2 meses', price: 22000, availability: 'Alta',
    startDate: '2026-06-15', endDate: '2026-08-15',
    description: 'Patrocinador oficial de la cobertura deportiva. Menciones + banner.',
    status: 'pausado', impressions: 87000, clicks: 5400, ctr: 6.2,
  },
  {
    id: 5, name: 'Menciones Programa Tarde', advertiser: 'Restaurante La Parrilla', radioName: 'Estéreo Capital',
    format: 'mencion', duration: '3 meses', price: 15000, availability: 'Alta',
    startDate: '2026-05-01', endDate: '2026-08-01',
    description: '2 menciones en vivo por hora durante el programa de la tarde.',
    status: 'activo', impressions: 115000, clicks: 7800, ctr: 6.8,
  },
  {
    id: 6, name: 'Banner Sidebar Premium', advertiser: 'Hotel Brisas del Pacífico', radioName: 'Radio Costa Azul',
    format: 'banner', duration: '2 meses', price: 18000, availability: 'Media',
    startDate: '2026-04-01', endDate: '2026-06-01',
    description: 'Banner sidebar 300x250 con segmentación geográfica.',
    status: 'archivado', impressions: 98000, clicks: 6200, ctr: 6.3,
  },
  {
    id: 7, name: 'Podcast Patrocinado', advertiser: 'Universidad Virtual', radioName: 'Radio Cultura Digital',
    format: 'audio', duration: '6 meses', price: 35000, availability: 'Alta',
    startDate: '2026-06-01', endDate: '2026-12-01',
    description: 'Patrocinio de podcast semanal. Menciones en apertura, cierre y 2 cortes.',
    status: 'activo', impressions: 68000, clicks: 4200, ctr: 6.2,
  },
  {
    id: 8, name: 'Banner Home Footer', advertiser: 'Ferretería Don Pepe', radioName: 'FM Horizonte',
    format: 'banner', duration: '1 mes', price: 5000, availability: 'Alta',
    startDate: '2026-07-01', endDate: '2026-08-01',
    description: 'Banner footer en home. Ideal para campañas locales de corta duración.',
    status: 'pausado', impressions: 28000, clicks: 1200, ctr: 4.3,
  },
];

export const offerFormatLabels: Record<string, { label: string; icon: string }> = {
  banner: { label: 'Banner', icon: 'ri-image-line' },
  audio: { label: 'Audio', icon: 'ri-volume-up-line' },
  video: { label: 'Video', icon: 'ri-vidicon-line' },
  patrocinio: { label: 'Patrocinio', icon: 'ri-medal-line' },
  mencion: { label: 'Mención', icon: 'ri-megaphone-line' },
};